import { IInteractive } from "../../interfaces/IInteractive";
import { IShowable } from "../../interfaces/IShowable";
import { GetWindowSize } from "../../utils/GetWindowSize";
import { RectSize } from "../../utils/RectSize";
import { LoaderFileKeys } from "../constant/AppConstants";
import { OptionsDataManager } from "../managers/OptionsDataManager";
import { AppSettings } from "../managers/AppSettings";
import { AppTimings } from "../data/AppConstants";


export class PopupWindow 
    extends Phaser.GameObjects.Container
    implements IInteractive, IShowable
{
    public imgScreenOverlay: Phaser.GameObjects.Image;
    // protected screenOverlayHitArea: Phaser.Geom.Rectangle;
    protected isShowing: boolean = true;
    protected isInteractive: boolean;
    /**
     * Tween connected to Show/Hide
     * Need this to offset bug: 
     * https://github.com/photonstorm/phaser/issues/6173
     */
    protected showableTween:Phaser.Tweens.Tween;


    /**
     * Toggle visibility
     * @param animated 
     * @returns 
     */
    public Toggle(animated: boolean = true): void
    {
        if (this.isShowing) {
            this.Hide(true);
        }
        else {
            this.Show(true);
        }
    }

    public Show(animated: boolean = true, onComplete:Function = undefined): void
    {
        // console.log("PopupBase("+this.name+")::Show",animated,onComplete);
        // console.log(">",this.scaleY, this.scene.tweens.getTweensOf(this, true).length);

        this.SetInteractive(true);

        // kill tweens
        // this.scene.tweens.killTweensOf(this);
        
        // this.scene.tweens.getTweensOf(this, true).forEach(tween=>{
        //     tween.stop();
        //     tween.destroy();
        // });

        if (this.showableTween != undefined) {
            // Stops the Tween immediately, whatever stage of progress it is at 
            // and flags it for removal by the TweenManager.
            // console.log(this.showableTween.destroy)
            this.showableTween.stop();
            // unsure if this works
            if (this.showableTween.destroy != undefined) {
                // console.log("destroyListeners");
                this.showableTween.destroy();
            }
            // doesnt seem to work
            this.scene.tweens.killTweensOf(this);
        }

        // reset
        this.scaleY = 0;

        // if animate
        const genericShowDuration = OptionsDataManager.GetTiming(AppTimings.genericShowDuration);
        if (animated) {
            this.showableTween = this.scene.tweens.add({
                targets: this,
                // alpha: 1,
                scaleY: 1,
                // y: 0,
                duration: genericShowDuration,
                ease: AppSettings.ease.genericShowHideEase,
                // onComplete: ()=>{
                //     if (onComplete != undefined) {
                //         onComplete();
                //     }
                //     // console.log("<(Show/delayed)",this.scaleY);
                // },
                onComplete: onComplete?.(),
            }) as Phaser.Tweens.Tween;
        }
        else {
            //
            this.scaleY = 1;
            // this.y = 0;
            // if (onComplete!=undefined) {
            //     onComplete();
            // }
            onComplete?.();
            // console.log("<",this.scaleY);
        }
        this.isShowing = true;
    }

    public Hide(animated: boolean = true, onComplete:Function = undefined): void
    {
        // console.log("PopupBase("+this.name+")::Hide",animated,onComplete);
        // console.log(">",this.scaleY, this.scene.tweens.getTweensOf(this, true).length);

        this.SetInteractive(false);

        // kill tweens
        // this.scene.tweens.killTweensOf(this);

        if (this.showableTween != undefined) {
            // Stops the Tween immediately, whatever stage of progress it is at 
            // and flags it for removal by the TweenManager.
            this.showableTween.stop();
            // unsure if this works
            if (this.showableTween.destroy != undefined) {
                // console.log("destroyListeners");
                this.showableTween.destroy();
            }
            // doesnt seem to work
            this.scene.tweens.killTweensOf(this);
        }

        // ref
        // const windowRect = GetWindowSize();
        
        // if animate
        const genericHideDuration = OptionsDataManager.GetTiming(AppTimings.genericHideDuration);
        if (animated) {
            this.showableTween = this.scene.tweens.add({
                targets: this,
                // alpha: ,
                scaleY: 0,
                // y: -windowRect.height,
                duration: genericHideDuration,
                ease: AppSettings.ease.genericShowHideEase,
                // onComplete: ()=>{
                //     if (onComplete != undefined) {
                //         onComplete();
                //     }
                //     // console.log("<(Hide/delayed)",this.scaleY);
                // },
                onComplete: onComplete?.(),
            }) as Phaser.Tweens.Tween;
        }
        else {
            // 
            this.scaleY = 0;
            // this.y = -windowRect.height;
            // if (onComplete!=undefined) {
            //     onComplete();
            // }
            onComplete?.();
            // console.log("<",this.scaleY);
        }
        this.isShowing = false;
    }

    public IsShowing(): boolean
    {
        return this.isShowing;
    }

    /**
     * SetInteractive on all children
     * NOTE: for base, this does not concern the overlay, 
     * which is always enabled to stop further propagation of mouse events
     */
    public SetInteractive(value: boolean): void
    {
        // override in subclass
    }

    public IsInteractive(): boolean
    {
        return this.isInteractive;
    }
    
    public Init(): void
    {
        // override in subclass
    }

    public Build(): void
    {
        this.imgScreenOverlay = this.scene.make.image({
            key: LoaderFileKeys.ui,
            frame: "rect-2x2-black.png", 
            alpha: 0.3
        });
        this.imgScreenOverlay.setOrigin(0);
        this.add(this.imgScreenOverlay);
    }
    
    /**
     * NOTE: subclasses' OnResize is called manually from parent unless registered in subclass
     * @param windowRect 
     */
    public OnResize(windowRect: RectSize): void
    {
        // override in subclass
        this.imgScreenOverlay.setDisplaySize(windowRect.width, windowRect.height);
        this.imgScreenOverlay.setInteractive();
    }
}